"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uuid = require("uuid");

var _variables = require("../common/variables.js");

var _utils = require("../common/utils.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _BackgroundColorContext = _interopRequireDefault(require("../BackgroundColorContext"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcSwitch = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var defaultChecked = _ref.defaultChecked,
      checked = _ref.checked,
      value = _ref.value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$labelPosition = _ref.labelPosition,
      labelPosition = _ref$labelPosition === void 0 ? "before" : _ref$labelPosition,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? false : _ref$optional,
      onChange = _ref.onChange,
      margin = _ref.margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "fitContent" : _ref$size,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _useState = (0, _react.useState)("switch-".concat((0, _uuid.v4)())),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      switchId = _useState2[0];

  var labelId = "label-".concat(switchId);

  var _useState3 = (0, _react.useState)(defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      innerChecked = _useState4[0],
      setInnerChecked = _useState4[1];

  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var backgroundType = (0, _react.useContext)(_BackgroundColorContext["default"]);
  var refTrack = (0, _react.useRef)(null);

  var handleOnKeyDown = function handleOnKeyDown(event) {
    switch (event.key) {
      case "Enter":
      case " ":
        //Space
        event.preventDefault();
        refTrack.current.focus();
        var isChecked = !(checked !== null && checked !== void 0 ? checked : innerChecked);
        setInnerChecked(isChecked);
        onChange === null || onChange === void 0 ? void 0 : onChange(isChecked);
        break;
    }
  };

  var handlerSwitchChange = function handlerSwitchChange(event) {
    checked !== null && checked !== void 0 ? checked : setInnerChecked(function (innerChecked) {
      return !innerChecked;
    });
    onChange === null || onChange === void 0 ? void 0 : onChange(checked ? !checked : !innerChecked);
  };

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme["switch"]
  }, /*#__PURE__*/_react["default"].createElement(SwitchContainer, {
    margin: margin,
    size: size,
    onKeyDown: handleOnKeyDown,
    disabled: disabled,
    onClick: !disabled ? handlerSwitchChange : undefined,
    ref: ref
  }, labelPosition === "before" && label && /*#__PURE__*/_react["default"].createElement(LabelContainer, {
    id: labelId,
    labelPosition: labelPosition,
    disabled: disabled,
    backgroundType: backgroundType,
    label: label
  }, label, " ", optional && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, translatedLabels.formFields.optionalLabel)), /*#__PURE__*/_react["default"].createElement(ValueInput, {
    type: "checkbox",
    name: name,
    "aria-hidden": true,
    value: value,
    disabled: disabled,
    checked: checked !== null && checked !== void 0 ? checked : innerChecked,
    readOnly: true
  }), /*#__PURE__*/_react["default"].createElement(SwitchBase, null, /*#__PURE__*/_react["default"].createElement(SwitchTrack, {
    role: "switch",
    backgroundType: backgroundType,
    "aria-checked": checked !== null && checked !== void 0 ? checked : innerChecked,
    "aria-disabled": disabled,
    disabled: disabled,
    "aria-labelledby": labelId,
    tabIndex: !disabled ? tabIndex : -1,
    ref: refTrack
  })), labelPosition === "after" && label && /*#__PURE__*/_react["default"].createElement(LabelContainer, {
    id: labelId,
    labelPosition: labelPosition,
    disabled: disabled,
    backgroundType: backgroundType,
    label: label
  }, optional && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, translatedLabels.formFields.optionalLabel), " ", label)));
});

var sizes = {
  small: "60px",
  medium: "240px",
  large: "480px",
  fillParent: "100%",
  fitContent: "fit-content"
};

var calculateWidth = function calculateWidth(margin, size) {
  return size === "fillParent" ? "calc(".concat(sizes[size], " - ").concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")") : sizes[size];
};

var getDisabledColor = function getDisabledColor(props, element, subelement) {
  switch (element) {
    case "track":
      switch (subelement) {
        case "check":
          return props.backgroundType && props.backgroundType === "dark" ? props.theme.disabledCheckedTrackBackgroundColorOnDark : props.theme.disabledCheckedTrackBackgroundColor;

        case "uncheck":
          return props.backgroundType && props.backgroundType === "dark" ? props.theme.disabledUncheckedTrackBackgroundColorOnDark : props.theme.disabledUncheckedTrackBackgroundColor;
      }

    case "thumb":
      switch (subelement) {
        case "check":
          return props.backgroundType && props.backgroundType === "dark" ? props.theme.disabledCheckedThumbBackgroundColorOnDark : props.theme.disabledCheckedThumbBackgroundColor;

        case "uncheck":
          return props.backgroundType && props.backgroundType === "dark" ? props.theme.disabledUncheckedThumbBackgroundColorOnDark : props.theme.disabledUncheckedThumbBackgroundColor;
      }

    case "label":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.disabledLabelFontColorOnDark : props.theme.disabledLabelFontColor;
  }
};

var getNotDisabledColor = function getNotDisabledColor(props, element, subelement) {
  switch (element) {
    case "track":
      switch (subelement) {
        case "check":
          return props.backgroundType && props.backgroundType === "dark" ? props.theme.checkedTrackBackgroundColorOnDark : props.theme.checkedTrackBackgroundColor;

        case "uncheck":
          return props.backgroundType && props.backgroundType === "dark" ? props.theme.uncheckedTrackBackgroundColorOnDark : props.theme.uncheckedTrackBackgroundColor;
      }

    case "thumb":
      switch (subelement) {
        case "check":
          return props.backgroundType && props.backgroundType === "dark" ? props.theme.checkedThumbBackgroundColorOnDark : props.theme.checkedThumbBackgroundColor;

        case "uncheck":
          return props.backgroundType && props.backgroundType === "dark" ? props.theme.uncheckedThumbBackgroundColorOnDark : props.theme.uncheckedThumbBackgroundColor;
      }

    case "label":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.labelFontColorOnDark : props.theme.labelFontColor;
  }
};

var SwitchContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  align-items: center;\n  width: ", ";\n  height: 40px;\n  cursor: ", ";\n\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return calculateWidth(props.margin, props.size);
}, function (props) {
  return props.disabled === true ? "not-allowed" : "pointer";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var LabelContainer = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: ", ";\n  opacity: 1;\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n\n  ", ";\n\n  ", "\n"])), function (props) {
  return props.disabled ? getDisabledColor(props, "label") : getNotDisabledColor(props, "label");
}, function (props) {
  return props.theme.labelFontFamily;
}, function (props) {
  return props.theme.labelFontSize;
}, function (props) {
  return props.disabled ? props.theme.disabledLabelFontStyle : props.theme.labelFontStyle;
}, function (props) {
  return props.theme.labelFontWeight;
}, function (props) {
  return !props.label ? "margin: 0px;" : props.labelPosition === "after" ? "margin-left: ".concat(props.theme.spaceBetweenLabelSwitch, ";") : "margin-right: ".concat(props.theme.spaceBetweenLabelSwitch, ";");
}, function (props) {
  return props.labelPosition === "before" && "order: -1";
});

var SwitchBase = _styledComponents["default"].label(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  margin: 0px 12px;\n"])));

var ValueInput = _styledComponents["default"].input(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: none;\n"])));

var SwitchTrack = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius: 15px;\n  width: ", ";\n  height: ", ";\n  position: relative;\n  cursor: ", ";\n\n  &:focus-visible {\n    outline: none;\n    ::before {\n      outline: ", ";\n      outline-offset: 6px;\n    }\n  }\n\n  /* Thumb element */\n  ::before {\n    content: \"\";\n    transform: initial;\n    position: absolute;\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    z-index: 1;\n    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);\n    bottom: -6px;\n    left: -4px;\n    transform: translateX(0px);\n    background-color: ", ";\n  }\n\n  /* Unchecked */\n  background-color: ", ";\n\n  /* Checked */\n  &[aria-checked=\"true\"] {\n    background-color: ", ";\n    ::before {\n      transform: translateX(", ");\n      background-color: ", ";\n    }\n  }\n"])), function (props) {
  return props.theme.trackWidth;
}, function (props) {
  return props.theme.trackHeight;
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  return "".concat(props.backgroundType === "dark" ? props.theme.thumbFocusColorOnDark : props.theme.thumbFocusColor, " solid 2px");
}, function (props) {
  return props.theme.thumbWidth;
}, function (props) {
  return props.theme.thumbHeight;
}, function (props) {
  return props.disabled ? getDisabledColor(props, "thumb", "uncheck") : getNotDisabledColor(props, "thumb", "uncheck");
}, function (props) {
  return props.disabled ? getDisabledColor(props, "track", "uncheck") : getNotDisabledColor(props, "track", "uncheck");
}, function (props) {
  return props.disabled ? getDisabledColor(props, "track", "check") : getNotDisabledColor(props, "track", "check");
}, function (props) {
  return props.theme.thumbShift;
}, function (props) {
  return props.disabled ? getDisabledColor(props, "thumb", "check") : getNotDisabledColor(props, "thumb", "check");
});

var _default = DxcSwitch;
exports["default"] = _default;